const isUsableNumber = (n: number | null | undefined): n is number => typeof n === "number" && Number.isFinite(n);

const clampPercent = (value: number): number => Math.max(0, Math.min(100, value));

export function computeDirectRingFill(actual: number | null | undefined, target: number): number {
    if (!isUsableNumber(actual) || !isUsableNumber(target) || target <= 0) return 0;
    return clampPercent((actual / target) * 100);
}

interface InverseRingFillOptions {
    ceiling?: number;
    ceilingMultiplier?: number;
}

export function computeInverseRingFill(
    actual: number | null | undefined,
    target: number,
    { ceilingMultiplier = 2, ceiling = target * ceilingMultiplier }: InverseRingFillOptions = {},
): number {
    if (!isUsableNumber(actual) || !isUsableNumber(target) || target <= 0) return 0;

    if (!isUsableNumber(ceiling) || ceiling <= target) return 0;

    if (actual <= target) return 100;
    if (actual >= ceiling) return 0;

    return clampPercent(((ceiling - actual) / (ceiling - target)) * 100);
}
